import { useState, useCallback, Dispatch, SetStateAction } from 'react';
import { FormData, validationRules, validateField, validateForm, formatNumber } from 'utils/validation';
import {
  registerPolarizationList,
  registerModulationList,
  reedSolomonCodeList,
  registerPCMCodingList,
  registerConvolutionalCodeList
} from 'pages/ManageSpacecraft/utils';

type ErrorState = Partial<Record<keyof FormData, string>>;

export const useSpaceCraftForm = (initialData: Partial<FormData>) => {
  const [formData, setFormData] = useState<FormData>({
    name: initialData?.name ?? '',
    noradId: initialData?.noradId ?? '',
    tleTitle: initialData?.tleTitle ?? '',
    tleFirst: initialData?.tleFirst ?? '',
    tleSecond: initialData?.tleSecond ?? '',
    centerFrequency: initialData?.centerFrequency ?? '',
    subcarrierFrequency: initialData?.subcarrierFrequency ?? '',
    framesyncword: initialData?.framesyncword ?? '',
    framesize: initialData?.framesize ?? '',
    bitRate: initialData?.bitRate ?? '',
    syn: initialData?.syn ?? 2,
    ctl: initialData?.ctl ?? 1,
    lts: initialData?.lts ?? 3,
    slip: initialData?.slip ?? 0,
    other: initialData?.other ?? '',
    modulation: initialData?.modulation ?? 0, 
    modulationName: initialData?.modulationName ?? '',
    polarization: initialData?.polarization ?? registerPolarizationList[0].value,
    polarizationName: initialData?.polarizationName ?? registerPolarizationList[0].label,
    convolutionalCode: initialData?.convolutionalCode ?? registerConvolutionalCodeList[0].value,
    convolutionalCodeName: initialData?.convolutionalCodeName ?? registerConvolutionalCodeList[0].label,
    reedSolomonCode: initialData?.reedSolomonCode ?? reedSolomonCodeList[0].value,
    reedSolomonCodeName: initialData?.reedSolomonCodeName ?? reedSolomonCodeList[0].label,
    pcmCoding: initialData?.pcmCoding ?? registerPCMCodingList[0].value,
    pcmCodingName: initialData?.pcmCodingName ?? registerPCMCodingList[0].label,
    // Uplink 전용 필드 초기값
    pcmCode: initialData?.pcmCode ?? '',
    idlePattern: initialData?.idlePattern ?? '',
    idlePatternLength: initialData?.idlePatternLength ?? '',
    preambleLength: initialData?.preambleLength ?? '',
    carrierFrequencyMhz: initialData?.carrierFrequencyMhz ?? '',
    operatingMode: initialData?.operatingMode ?? '',
    ifCarrierLevel: initialData?.ifCarrierLevel ?? '',
    sweepRate: initialData?.sweepRate ?? '',
    sweepRange: initialData?.sweepRange ?? '',
  });

  const [errors, setErrors] = useState<ErrorState>({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = useCallback((field: keyof FormData, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    validateField(field, value, setErrors);
  }, []);

  const validateFormData = useCallback(() => {
    return validateForm(formData, setErrors);
  }, [formData]);

  return {
    formData,
    errors,
    setErrors,
    isLoading,
    setIsLoading,
    handleInputChange,
    validateForm: validateFormData,
    setFormData,
  };
};

export { validationRules, validateField, validateForm, formatNumber };
export type { FormData };